import { baseUrl } from "./requestDetails";

export const externalAPIURL = {
  GET_PRODUCTS: `${baseUrl}products`,
};
